import { render, staticRenderFns } from "./DataSetContextMenu.vue?vue&type=template&id=90190d94"
import script from "./DataSetContextMenu.vue?vue&type=script&lang=js"
export * from "./DataSetContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports